import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { YoutubeEmbedVideoComponent } from '../../../new-v2-component/youtube-embed-video/youtube-embed-video.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'sm-employee-log',
  templateUrl: './employee-log.component.html',
  styleUrls: ['./employee-log.component.scss']
})
export class EmployeeLogComponent implements OnInit, OnDestroy {
  repeatArray:any
  employeeLogData: any = {}
  toshowData:boolean =true
  loader: boolean = false
  _apisub: Subscription
  constructor(private _apiservice:ApiService,private router: Router,  private dialog:MatDialog) {

    this._apisub = this._apiservice.apiResult.subscribe(resdata =>{
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_TODAYS_EMPLOYEE_LOG_FOR_DASHBOARD_COUNT){
        this.employeeLogData = {}
        if(resdata.result){
          this.employeeLogData = resdata.result
        }
      
        this.loader = false
        }
    })

   }

  ngOnInit(): void {
    this.loader = true
    this._apiservice.getTodaysEmployeeLogCountForDashboard('4','1')
  }
  viewAll(){
    if(this.employeeLogData?.total_dutylogs > 0){
      this.router.navigate(['all-employee-log'])

    }
  }

  openvideo(){
    this.dialog.open(YoutubeEmbedVideoComponent,{
    width:'1000px',
    disableClose:true,
    data:{
      link:"",
      title: 'Employee log'
    }})
    }

    formatToAmPm(dateString:any) {
      const date = new Date(dateString);
      let hours = date.getHours();
      const minutes = date.getMinutes();
      const ampm = hours >= 12 ? 'PM' : 'AM';
      
      hours = hours % 12;
      hours = hours ? hours : 12; // Hour '0' should be '12'
      const minutesStr = minutes < 10 ? '0' + minutes : minutes;
  
      return `${hours}:${minutesStr} ${ampm}`;
  }

  ngOnDestroy(): void {
    this._apisub.unsubscribe()
  }
}
